
import { Injectable,Injector} from "@angular/core";

import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Resolve
} from "@angular/router";
import { HttpService } from "../../modules/http-with-injector/http.service";
//import { getSubdomain } from "../../globals/_classes/functions";
import { PLATFORM_ID,Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
//import { CookieService } from 'ngx-cookie';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class HomeResoveService implements Resolve<any> {
  constructor(private injector:Injector,@Inject(DOCUMENT) private document: any,@Inject(PLATFORM_ID) private platform: Object,private http: HttpService) {

  }
  resolve(router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
 // if(isPlatformServer(this.platform)){
   // console.log(this.document.location)
    //console.log("in server platform")
    let url =this.document.location.href
   let  urlParts = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(url);
    let domain = urlParts[1]
    //console.log("host: " + urlParts[1],urlParts[2]);
    const subDomaPos = domain.search("leaperdev.rocks");
    let subDomain = '';
    if (subDomaPos !== -1 ) {
      subDomain = domain.split(".")[0]
    } else {
      subDomain = domain;
    }
    // if (subDomain === "beach-day-llc") {
    //   this._script.loadScript('body', 'assets/js/admin/beach_day_tawk.js');
    // }

  let url_key;
  //if (isPlatformBrowser(this.platform)) {
    const path = this.document.location.href;
    console.log(path)
    if (path.includes("video-wall")) {
      url_key='guest-token';
    }
    else{
      url_key='get-settings';
    }
    return this.http
  .get(
    url_key+`?store_name=${
      subDomain.includes("localhost") ? "teststore17" : subDomain
    }`
  )
  .toPromise()
  .then(res => {
    if (res.status === "OK") {
      if (
        res.result.location &&
        res.result.location.id &&
        res.result.store.token
      ) {
        const result = res.result;
        if(isPlatformBrowser(this.platform)){
          if (res.result.store.id == 1299) {
            res.result.store.layout.layout_id = 5;
          }
          const currentLoc = JSON.parse(localStorage.getItem('current_location'));
          // sessionStorage.setItem("online_store", JSON.stringify(res.result));
          if (!currentLoc || !Array.isArray(result.locations) ||
            !result.locations.find(loc => loc.id == currentLoc.id)) {
            // console.log('1 currentLoc: ', currentLoc);
            // console.log('1 result.locations: ', result.locations);
            // console.log('1 find: ', result.locations.find(loc => loc.id == currentLoc.id));
            localStorage.setItem("current_location", JSON.stringify(result.location));
            sessionStorage.setItem("online_store", JSON.stringify(result));
          } else {
            result['location'] = currentLoc;
            // console.log('2 result: ', result);
            sessionStorage.setItem("online_store", JSON.stringify(result));
          }
          // sessionStorage.setItem("online_store", JSON.stringify(res.result));
        }
        // sessionStorage.setItem("online_store", JSON.stringify(res.result));
        // console.log("result",res.result);
        this.document.online_store = JSON.stringify(res.result);
        //this.cookieService.put("online_store",JSON.stringify(res.result))
        //console.log(this.cookieService.get("online_store"))

       this._setLocationFromQueryParam(router);

        return res.result;
      }
    }
    return null;
  })
  .catch(err => {
    console.log(err);
    return null;
  });
  //}
  // if(isPlatformBrowser(this.platform)){
  //   alert("is platform browser")
  //   const domain = window.location.host;
  //   const subDomaPos = domain.search("rentmy.co");
  //   let subDomain = '';
  //   if (subDomaPos !== -1 ) {
  //     subDomain = domain.split(".")[0]
  //   } else {
  //     subDomain = domain;
  //   }
  //   // if (subDomain === "beach-day-llc") {
  //   //   this._script.loadScript('body', 'assets/js/admin/beach_day_tawk.js');
  //   // }

  // let url_key;
  // //if (isPlatformBrowser(this.platform)) {
  //   const path = window.location.href;
  //   console.log(path)
  //   if (path.includes("video-wall")) {
  //     url_key='guest-token';
  //   }
  //   else{
  //     url_key='get-settings';
  //   }
  // //}


  // // beach-day-llc
  // return this.http
  // .get(
  //   url_key+`?store_name=${
  //     subDomain.includes("localhost") ? "teststore09" : subDomain
  //   }`
  // )
  // .toPromise()
  // .then(res => {
  //   if (res.status === "OK") {
  //     if (
  //       res.result.location &&
  //       res.result.location.id &&
  //       res.result.store.token
  //     ) {
  //       sessionStorage.setItem("online_store", JSON.stringify(res.result));
  //       this.cookieService.put("online_store",JSON.stringify(res.result))
  //       return res.result;
  //     }
  //   }
  //   return null;
  // })
  // .catch(err => {
  //   console.log(err);
  //   return null;
  // });



  // }
    // ebikekrakowrental
      //const subDom = getSubdomain();

  }

  private _setLocationFromQueryParam(router: ActivatedRouteSnapshot): void {


    if (router.queryParams?.location) {

      let locId = router.queryParams?.location;

      let online_store = JSON.parse(sessionStorage.getItem('online_store'));
      if (online_store?.locations && Array.isArray(online_store.locations)) {

        let location = online_store.locations.find(loc => loc.id == locId);

        if (!location) return;

        online_store['location'] = location;
        localStorage.setItem('current_location', JSON.stringify(location));
        sessionStorage.setItem('online_store', JSON.stringify(online_store));

      }
    }

  }

}
